"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APHorizontalBarChart = void 0;
var _reactChartjs = require("react-chartjs-2");
var _react = _interopRequireDefault(require("react"));
var _chart = require("chart.js");
var _chartjsPluginAnnotation = _interopRequireDefault(require("chartjs-plugin-annotation"));
var _accounting = _interopRequireDefault(require("accounting"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var APHorizontalBarChart = function APHorizontalBarChart(props) {
  _chart.Chart.register(_chartjsPluginAnnotation["default"]);
  var chartData = props.chartData,
    _props$height = props.height,
    height = _props$height === void 0 ? 150 : _props$height,
    _props$width = props.width,
    width = _props$width === void 0 ? 900 : _props$width,
    xAxisMax = props.xAxisMax,
    xAxisMin = props.xAxisMin,
    ticks = props.ticks,
    breachedVm = props.breachedVm,
    vmPercentage = props.vmPercentage,
    _props$mtmPercentage = props.mtmPercentage,
    mtmPercentage = _props$mtmPercentage === void 0 ? 'MTM Percentage' : _props$mtmPercentage,
    europeanLocale = props.europeanLocale;
  var setChartRules = function setChartRules(chartData, breachedVm) {
    // RED
    if (chartData < 0 && breachedVm) {
      return '#BD251A';
    }
    // AMBER
    if (chartData < 0 && !breachedVm) {
      return '#FFC107';
    }
    // GREEN
    if (chartData >= 0) {
      return '#1E8777';
    }
    return '#BD251A';
  };
  var getContent = function getContent(chartData) {
    return chartData.length ? ["".concat(_accounting["default"].format(chartData[0], 2, europeanLocale ? '.' : ',', europeanLocale ? ',' : '.'), "%")] : [];
  };
  var defaultDash = [8, 4];
  var backgroundColor = setChartRules(chartData[0], breachedVm);
  var data = {
    labels: [''],
    datasets: [{
      data: chartData,
      backgroundColor: backgroundColor,
      barThickness: 9,
      borderRadius: 10
    }]
  };
  var options = {
    animation: {
      duration: 1500
    },
    maintainAspectRatio: false,
    indexAxis: 'y',
    layout: {
      padding: {
        left: 50
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      },
      annotation: {
        annotations: {
          mtmPercentageTitle: {
            type: 'label',
            xValue: xAxisMax,
            yValue: -0.2,
            position: {
              x: 'end'
            },
            content: [mtmPercentage],
            font: {
              size: 14
            }
          },
          mtmPercentage: {
            type: 'label',
            xValue: xAxisMax,
            yValue: 0.25,
            color: backgroundColor,
            position: {
              x: 'end'
            },
            content: getContent(chartData),
            font: {
              size: 32
            }
          },
          arrow: {
            type: 'label',
            yValue: 0.004,
            xValue: chartData[0] * 1.02,
            color: backgroundColor,
            content: chartData[0] && chartData[0] < 0 ? "\u276E\u276E " : "\u276F\u276F"
          }
        }
      }
    },
    scales: {
      y: {
        position: 'center',
        grid: {
          display: false
        }
      },
      x: {
        position: 'top',
        max: xAxisMax,
        min: xAxisMin,
        afterBuildTicks: function afterBuildTicks(axis) {
          return axis.ticks = ticks.map(function (v) {
            return {
              value: v.value
            };
          });
        },
        ticks: {
          callback: function callback(val, index) {
            return ticks[index].percentage;
          },
          maxRotation: 0,
          minRotation: 0,
          padding: 18,
          font: {
            size: 16
          }
        },
        grid: {
          drawBorder: false,
          drawTicks: false
        }
      },
      x1: {
        position: 'bottom',
        max: xAxisMax,
        min: xAxisMin,
        afterBuildTicks: function afterBuildTicks(axis) {
          return axis.ticks = ticks.map(function (v) {
            return {
              value: v.value
            };
          });
        },
        ticks: {
          callback: function callback(val, index) {
            return ticks[index].amount;
          },
          color: '#343434',
          labelOffset: 0,
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
          padding: 13,
          font: {
            size: 12
          }
        },
        grid: {
          drawTicks: false
        }
      },
      vm: {
        display: vmPercentage !== undefined,
        position: 'bottom',
        max: xAxisMax,
        min: xAxisMin,
        afterBuildTicks: function afterBuildTicks(axis) {
          return axis.ticks = [{
            value: vmPercentage || 0,
            label: _accounting["default"].format(vmPercentage, 2, europeanLocale ? '.' : ',', europeanLocale ? ',' : '.') + '%'
          }];
        },
        ticks: {
          display: false
        },
        grid: {
          drawBorder: false,
          drawTicks: false,
          borderDash: defaultDash,
          color: '#666666'
        }
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "".concat(width, "px"),
      height: "".concat(height, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactChartjs.Bar, {
    data: data,
    options: options
  }));
};
exports.APHorizontalBarChart = APHorizontalBarChart;